import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './main-component/App/App.jsx'
import { ParallaxProvider } from 'react-scroll-parallax'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
import { store, persistor } from './store/index'
import 'bootstrap/dist/css/bootstrap.min.css'
// Font Awesome loaded from CDN in index.html
import './css/themify-icons.css'
import './css/animate.css'
import './css/flaticon_medically.css'
import './sass/style.scss'
import './typography-system.css'
import './section-title-fix.css'
import './service-card-font-fix.css'
import './service-section-center-fix.css'
import './cta-section-gradient-fix.css'
import './mobile-menu-style-fix.css'
import './mobile-complete-styling.css'
import './hero-mobile-final.css'
import './ultimate-hero-fix.css'
import './global-improvements.css'
import './footer-professional.css'
import './cta-force-identical.css'
import './cta-text-fix.css'
import './cta-form-improved.css'
import './cta-horizontal-clean.css'
import './hero-nuclear-option.css'
import './hero-absolute-fix.css'
import './burger-menu-black-text.css'
import './mobile-hero-center.css'
import './desktop-navbar-white.css'
import './navbar-logo-white.css'
import './navbar-all-white.css'
import './navbar-scroll-colors.css'
import './navbar-mobile-sticky.css'
import './mobile-burger-black.css'
import './hero-title-override.css'
import './cta-green-gradient.css'
import './international-button-hover-fix.css'
import './international-hero-fix.css'

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ParallaxProvider>
          <App />
        </ParallaxProvider>
      </PersistGate>
    </Provider>
  </React.StrictMode>
)
